import WriteForm from "@/pages/example/demo_1/forms/writeForm";
import ReadText from "@/pages/example/multModal/modalPanel";

const Config = {
  writeModal: {
    key: "writeModal",
    width: 600, // 自定义模态框宽度
    title: "回复内容", // 模态窗口的标题
    content: WriteForm, // 自定义 jsx内容
  },
  readModal: {
    key: "readModal",
    width: 800, // 自定义模态框宽度
    title: "查看内容", // 模态窗口的标题
    content: WriteForm, // 自定义 jsx内容
  },
  readModal1: {
    key: "readModal1",
    width: 500, // 自定义模态框宽度
    title: "查看内容", // 模态窗口的标题
    content: ReadText, // 自定义 jsx内容
  },
};

export default Config;



// WEBPACK FOOTER //
// ./src/AntD/modals_config/config.js